<ng-template #addressDetails let-address="address" let-i="index">
  <div class="mat-body-2 text text-content mb-2" id="checkout_view_address_list_item{{ i }}-address">
    <div class="address-list-item__address_title mb-10">
      {{ 'COMMON.ONBOARDING.START_PAGE.ADDRESS.TITLE' | translate }}
    </div>
    <div class="address-list-item__recipient_details mb-6" id="checkout_view_address_list_item{{ i }}_address">
      {{ [address?.street_number, address?.street_name, address?.apartment].join(' ').trim() }}
    </div>
    @if (address?.rural_postal_address) {
    <div class="address-list-item__recipient_details mb-6" id="checkout_view_address_list_item{{ i }}_address_rural">
      {{ address?.rural_postal_address }}
    </div>
    }

    <div id="checkout_view_address_list_item{{ i }}_address2" class="address-list-item__recipient_details mb-6">
      <span>{{ [address?.city, address?.province, address?.country].join(', ').trim() }}</span>
    </div>
    <div id="checkout_view_address_list_item{{ i }}_address2" class="address-list-item__recipient_details">
      <span>{{ address?.postal_code }}</span>
    </div>
  </div>
</ng-template>

<ng-template #addressMenu let-address="address" let-i="index">
  @if (showMenuButton) {
  <pbb-menu
    style="align-self: center"
    (click)="$event.stopPropagation()"
    [menuTitleKey]="'COMMON.ONBOARDING.START_PAGE.ADDRESS.TITLE'"
    [reverseButtonIcon]="true"
    id="address_item{{ i }}_menu"
    idLabel="address_item{{ i }}"
    menuAriaLabel="{{ [address?.street_number, address?.street_name, address?.apartment].join(' ').trim() }}"
    [options]="options"
    [item]="address"
    [itemRef]="address.shipping_address_ref"
    [openDesktopDialog]="true"
    [itemIndex]="i"
    (menuAction)="menuAction.emit($event)"
  ></pbb-menu>
  }
</ng-template>

<ng-template #addressDefault let-address="address">
  @if (defaultShippingAddressRef === address.shipping_address_ref) {
    <div class="default-chip">
      <mat-chip-listbox [attr.aria-label]="'ARIA_LABEL.ADDRESS_FLAGS' | translate">
        <mat-basic-chip
          class="default-chip primary-chip"
          id="address-list_default-chip"
          [attr.aria-label]="'ARIA_LABEL.DEFAULT_ADDRESS' | translate"
        >
          <mat-icon [attr.aria-label]="'ARIA_LABEL.CHECK_CIRCLE' | translate">check_circle</mat-icon>
          <div class="mat-caption">{{ 'COMMON.DEFAULT' | translate }}</div>
        </mat-basic-chip>
      </mat-chip-listbox>
    </div>
    }
</ng-template>

@if(!selectable) {
<mat-list>
  @for (address of addresses; track $index; let i = $index) {
  <mat-list-item
    id="checkout_view_address_list_item{{ i }}"
    [class.selected-address]="selectable && selectedShippingAddressRef === address.shipping_address_ref"
  >
    <div class="flex-row">
      <ng-container *ngTemplateOutlet="addressDetails; context: { address: address, index: i }"></ng-container>
      <div class="flex-col">
        <ng-container *ngTemplateOutlet="addressMenu; context: { address: address, index: i }"></ng-container>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="addressDefault; context: { address: address, index: i }"></ng-container>
  </mat-list-item>
  }
</mat-list>
} @else {
<mat-radio-group
  [(ngModel)]="selectedShippingAddressRef"
  (ngModelChange)="clickAddress($event)"
  class="radio-button-list"
>
  @for (address of addresses; track $index; let i = $index) {
  <div class="flex-row pbb-address-list-item">
    <pbb-radio
      [id]="'checkout_view_address_list_item' + i"
      labelPosition="before"
      [value]="address.shipping_address_ref"
      [checked]="address.shipping_address_ref === selectedShippingAddressRef"
      [cssClass]="'mat-body-2 background-transparent flex-label-radio'"
    >
      <ng-container *ngTemplateOutlet="addressDetails; context: { address: address, index: i }"></ng-container>
    </pbb-radio>
    <div class="flex-col pbb-address-list-item-options">
      <ng-container *ngTemplateOutlet="addressMenu; context: { address: address, index: i }"></ng-container>
      <ng-container *ngTemplateOutlet="addressDefault; context: { address: address, index: i }"></ng-container>
    </div>
  </div>
  }
</mat-radio-group>
}
